import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import { usePageMeta } from '@/hooks/usePageMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Pagination from '@/components/feature/Pagination';
import NewsCard from '@/components/feature/NewsCard';

const PAGE_SIZE = 6;

export default function News() {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Math.max(1, Number(searchParams.get('page')) || 1);

  usePageMeta({
    title: '最新影视资讯 - 北条麻妃电影',
    description:
      '北条麻妃电影资讯频道，提供影展动态、作品访谈、经典重映与片场消息等最新影视资讯，帮助影迷及时了解相关动态。',
    keywords: '北条麻妃电影资讯,影视动态,新片消息,影展,访谈,重映',
  });

  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const items = useMemo(
    () => newsList.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [page],
  );

  const goPage = (p: number) => {
    const next = new URLSearchParams(searchParams);
    if (p <= 1) next.delete('page');
    else next.set('page', String(p));
    setSearchParams(next, { replace: true });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <section className="border-b border-background-200 bg-background-100/70">
        <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-10">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '资讯动态' }]} />
          <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">最新影视资讯</h1>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            汇总北条麻妃相关的最新影视资讯，包括影展入围、作品访谈、经典重映与片场动态，帮助你及时掌握相关消息。
          </p>
        </div>
      </section>

      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-12">
        {newsList.length === 0 ? (
          <div className="flex flex-col items-center py-16 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
              <i className="ri-newspaper-line text-2xl"></i>
            </span>
            <h2 className="mt-5 text-lg font-semibold text-foreground-900">暂无资讯内容</h2>
            <p className="mt-2 text-sm text-foreground-500">新的资讯正在整理中，请稍后再来看看。</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
              {items.map((item, i) => (
                <NewsCard key={item.id} item={item} index={i} />
              ))}
            </div>
            <Pagination current={page} totalPages={totalPages} onChange={goPage} />
          </>
        )}
      </div>
    </>
  );
}